module.exports = __webpack_public_path__ + "img/manageCenter.af64c118.png";